/* OYEN-CUSTOM start: variant title/description in PDP + quick-view */
(function () {
  if (window.__oyenVariantCopyBound) return;
  window.__oyenVariantCopyBound = true;

  function closestRoot(el) {
    return (el && el.closest && el.closest('product-info, .quick-view__content')) || null;
  }

  function parseCopy(root) {
    if (!root) return null;
    var node = root.querySelector('[data-oyen-variant-copy]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyCopy(root, variantId) {
    if (!root || !variantId) return;
    var map = parseCopy(root);
    if (!map) return;
    var copy = map[String(variantId)];
    if (!copy) return;

    root.querySelectorAll('[data-oyen-title]').forEach(function (el) {
      if (copy.title == null || copy.title === '') return;
      var split = el.querySelector('split-words');
      (split || el).textContent = copy.title;
    });

    root.querySelectorAll('[data-oyen-description]').forEach(function (el) {
      if (copy.description == null) return;
      el.innerHTML = copy.description;
    });
  }

  function applyFromEventTarget(target, variantId) {
    var root = closestRoot(target);
    if (root) {
      applyCopy(root, variantId);
      return;
    }
    document.querySelectorAll('product-info').forEach(function (info) {
      applyCopy(info, variantId);
    });
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || t.name !== 'id' || !t.value) return;
    applyFromEventTarget(t, t.value);
  });

  document.addEventListener('quickview:loaded', function () {
    document.querySelectorAll('.quick-view__content product-info, .quick-view__content').forEach(function (info) {
      var formId = info.getAttribute && info.getAttribute('form');
      var form = formId ? document.getElementById(formId) : null;
      var input =
        (form && form.querySelector('input[name="id"]')) ||
        info.querySelector('input[name="id"]');
      if (input && input.value) applyCopy(info, input.value);
    });
  });

  function bindPubsub() {
    if (!window.theme || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS || !theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      return false;
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
      var data = payload && payload.data;
      var variant = data && data.variant;
      if (!variant || !variant.id) return;
      var selector = 'product-info[data-section-id="' + data.sectionId + '"][data-product-id="' + data.productId + '"]';
      var info = document.querySelector(selector);
      if (info) applyCopy(info, variant.id);
    });
    return true;
  }

  if (!bindPubsub()) {
    document.addEventListener('DOMContentLoaded', bindPubsub);
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (bindPubsub() || tries > 40) clearInterval(timer);
    }, 250);
  }
})();
/* OYEN-CUSTOM end */